"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.invite = void 0;
const immer_1 = require("immer");
const actions = __importStar(require("../../../shared/store/action_constants"));
const defaultState = {
    inviteEmailInfo: null,
    teamTreeInvite: [],
    linkList: [],
    inviteLinkInfo: null,
    linkToken: '',
    mailToken: '',
    errCode: null,
};
const findParent = (data, id) => {
    return data.reduce((preValue, item) => {
        if (preValue) {
            return preValue;
        }
        if (item.teamId === id) {
            return item;
        }
        if (item.children) {
            return findParent(item.children, id);
        }
        return null;
    }, null);
};
const reUpdateTeamTree = (originTree, parentId, childrenTree) => {
    const parent = findParent(originTree, parentId);
    if (!parent) {
        return;
    }
    parent.children = childrenTree;
};
exports.invite = (0, immer_1.produce)((data = defaultState, action) => {
    switch (action.type) {
        case actions.UPDATE_INVITE_EMAIL_INFO: {
            data.inviteEmailInfo = action.payload;
            return data;
        }
        case actions.UPDATE_TEAM_TREE_INVITE: {
            data.teamTreeInvite = action.payload;
            return data;
        }
        case actions.UPDATE_SUB_TEAM_TREE_INVITE: {
            const { parentId, childrenTree } = action.payload;
            reUpdateTeamTree(data.teamTreeInvite, parentId, childrenTree);
            return data;
        }
        case actions.UPDATE_LINK_LIST: {
            data.linkList = action.payload;
            return data;
        }
        case actions.UPDATE_INVITE_LINK_INFO: {
            data.inviteLinkInfo = action.payload;
            return data;
        }
        case actions.UPDATE_LINK_TOKEN: {
            data.linkToken = action.payload;
            return data;
        }
        case actions.UPDATE_MAIL_TOKEN: {
            data.mailToken = action.payload;
            return data;
        }
        case actions.UPDATE_INVITE_ERR_CODE: {
            data.errCode = action.payload;
            return data;
        }
        default:
            return data;
    }
}, defaultState);
//# sourceMappingURL=invite.js.map